import React, { useEffect } from 'react'
import { Modal } from 'antd'
import classNames from '../Header.module.scss'
import { MemberRole } from 'helpers/Authorization'
import useGetUserById from 'data/useGetUserById'

export default function ModalProfile(props) {
  const { active, setActive, setActivePassword, setActiveEditProfile, userId, setProfile } = props
  const { data: profile } = useGetUserById(userId, null, { enabled: Boolean(userId), keepPreviousData: true })
  
  const handleProfileName = (name) => {
    let result = ''
    let count = 1
    const split = name?.split(' ')
    split?.map((x)=> {
      if (x && count <= 2) {
        count = count + 1
        result += x?.[0]
      }
    })
    return (result).toUpperCase()
  }

  useEffect(()=>{
    setProfile(profile)
  },[profile])

  return (
    <Modal
      style={{
        justifyContent: 'center',
        alignItems: 'center'
      }}
      visible={active}
      footer={null}
      onCancel={() => setActive(!active)}
    >
      <div className={classNames.profileContainer}>
        <div className={classNames.profileCircle}>
          {handleProfileName(profile?.fullName)}
        </div>
        {
          MemberRole() &&
          <div className={classNames.contentWrapper}>
            <div className={classNames.contentLeft}>
              Unit
            </div>
            <div className={classNames.contentRight}>
              {profile?.unit || '-'}
            </div>
          </div>
        }
        <div className={classNames.contentWrapper}>
          <div className={classNames.contentLeft}>
            Nama
          </div>
          <div className={classNames.contentRight}>
            {profile?.fullName || '-'}
          </div>
        </div>
        <div className={classNames.contentWrapper}>
          <div className={classNames.contentLeft}>
            Email
          </div>
          <div className={classNames.contentRight}>
            {profile?.email || '-'}
          </div>
        </div>
        <div className={classNames.contentWrapper}>
          <div className={classNames.contentLeft}>
            HP
          </div>
          <div className={classNames.contentRight}>
            {profile?.phone || '-'}
          </div>
        </div>
        <div className={classNames.footer}>
          <div className={classNames.btn} onClick={()=>{
            setActiveEditProfile(true)
            setActive(!active)
          }}>
            Ubah Profil
          </div>
          <div className={classNames.btn} onClick={()=>{
            setActivePassword(true)
            setActive(!active)
          }}>
            Ganti Password
          </div>
        </div>
      </div>
    </Modal>
  )
}
